module.exports = __webpack_public_path__ + "static/media/wps.4a1851e6.svg";